import { strings } from "../../../localization";
import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	GridItem,
	IconWarningLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, {useEffect} from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { useNavigateCustom } from "../../../hooks";

export const LackPeriod: React.FC = () => {
	const navigation = useNavigateCustom();
	const { authenticationStore } = useGlobalStore();
	const errorInfo = strings.components.connectionFeedback.errors;
	const { isDesktopOrBigger } = useScreenSize();
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	const onLogoutPress = React.useCallback(
		() => {
			addAnalyticEvent({
				component: "body",
				action: "click.button",
				description: errorInfo.onLockedDateRange.buttons.primaryButton,
				step: "fgts:tente-conectar-amanha",
				value: "",
			}, {applySanitize: true});
			authenticationStore.logout();
			navigation("/");
		},
		[],
	);

	useEffect(()=>{
		addAnalyticEvent({
			component: "body",
			action: "view-error",
			description: "tente-conectar-amanha",
			step: "fgts:tente-conectar-amanha",
			value: "",
			event: "non_interaction",
		}, {applySanitize: true});

		updatePageView({
			name: "Vivo Money FGTS Tente Conectar Amanhã",
			pagePath: "/fgts/tente-conectar-amanha",
		});
	},[]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
						title={errorInfo.lackPeriod.title}
						description={errorInfo.lackPeriod.text}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<ButtonPrimary
								onPress={onLogoutPress}
								showSpinner={false}
								disabled={false}
								style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
							>
								<Text3 medium color={skinVars.colors.textButtonPrimary}>
									{errorInfo.lackPeriod.buttons.primaryButton}
								</Text3>
							</ButtonPrimary>
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
};

export default LackPeriod;
